import Auth from 'j-toker';

import { apiGet, apiPut, apiPost } from 'helpers/ApiHelper';
import * as notifications from 'actions/notificationActions';

import { toISO8601DateTimeString } from 'helpers/Formatter';
import { deepDiver } from 'helpers/utilities';

import { SAVE_LOGS, CLEAR_LOGS } from './types';

export const saveLogs = logs => ({
  type: SAVE_LOGS,
  logs,
});

export const clearLogs = () => ({ type: CLEAR_LOGS });

export function getLogs() {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/landlords/logs/')
        .done(response => {
          dispatch(saveLogs(response.logs));
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
        }),
    });
  };
}

export function createOrUpdateLog(formData) {
  if (formData.id) {
    return updateLog(formData);
  }

  return createLog(formData);
}

export function createLog(formData) {
  const preppedFormData = prepFormData(formData);

  return (dispatch, getState) => {
    return dispatch({
      payload: apiPost(Auth.getApiUrl() + '/landlords/logs', preppedFormData)
        .done(response => {
          dispatch(notifications.showSuccess('createdLog'));
          dispatch(getLogs());
          return true;
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
          return false;
        }),
    });
  };
}

export function updateLog(formData) {
  return (dispatch, getState) => {
    return dispatch({
      payload: apiPut(Auth.getApiUrl() + `/landlords/logs/${formData.id}`, formData)
        .done(response => {
          dispatch(notifications.showSuccess('updatedLog'));
          dispatch(getLogs());
          return true;
        })
        .catch(error => {
          dispatch(notifications.showFailure(error));
          console.error('request failed', error);
          return false;
        }),
    });
  };
}

function prepFormData(data) {
  const formData = JSON.parse(JSON.stringify(data));

  formData.property_id = deepDiver(formData, 'property.value');
  formData.unit_id = deepDiver(formData, 'unit_selected.value');
  if (formData.unit_id === 'None') formData.unit_id = null;
  formData.lead_id = deepDiver(formData, 'tenant.value');

  formData.log_date = toISO8601DateTimeString(formData.log_date);

  return formData;
}
